<ng-container *ngIf="loading; else form">
  <mat-spinner
    class="loading-spinner"
    color="primary"
    diameter="75"
  ></mat-spinner>
</ng-container>
<ng-template #form>
  <div class="create-edit-task-container">
    <ng-container *ngIf="taskId == null; else existingTask">
      <h2>Nieuwe taak</h2>
    </ng-container>
    <ng-template #existingTask>
      <h2>Taak #{{ taskId }}</h2>
    </ng-template>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            [(ngModel)]="task.requestingUserId"
            placeholder="Kies"
          >
            <mat-option
              *ngFor="let option of employeeChoices"
              [value]="option.user.id"
            >
              {{ option.user.firstName | personName : option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="form-field left-margin" appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select placeholder="Maak een keuze" [(ngModel)]="selected">
            <mat-option
              *ngFor="let option of availableOptions"
              [value]="option"
            >
              {{ getOptionLabel(option) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="task.createdAtDateTime != null">
          <div class="align-with-requester">
            Aangemaakt:
            {{ task.createdAtDateTime | formatDate : '' : 'dd/MM/yyyy HH:mm' }}
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="!archiving; else isArchiving">
        <button
          *ngIf="taskId != null"
          mat-button
          class="button archive-button"
          (click)="archive()"
        >
          Wis
        </button>
      </ng-container>
      <ng-template #isArchiving>
        <mat-spinner color="primary" diameter="48"></mat-spinner>
      </ng-template>
    </div>
    <textarea-input
      [initContent]="task.subject"
      [placeholder]="'Onderwerp'"
      (answer)="task.subject = $event"
      [focusAndSelect]="focusSubjectField"
    ></textarea-input>
    <div class="do-pad-bottom">
      <textarea-input
        [initContent]="task.description"
        [placeholder]="'Omschrijving'"
        [client]="true"
        (answer)="task.description = $event"
      ></textarea-input>
    </div>
    <div class="d-flex do-pad-bottom">
      <div>
        <yes-no
          [title]="'Atelier nodig'"
          [flexRow]="false"
          [nullIsFalse]="false"
          [value]="task.needAtelier"
          [neverShowExtraInstructions]="true"
          (answer)="task.needAtelier = $event"
        ></yes-no>
      </div>
      <div
        *ngIf="task.needAtelier"
        class="left-space flex-horizontally whole-width"
      >
        <div class="whole-width">
          <textarea-input
            [initContent]="task.atelierInfo"
            [placeholder]="'Info atelier'"
            (answer)="task.atelierInfo = $event"
          ></textarea-input>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="uploader-container">
        <immo-task-asset-uploader
          [task]="task"
          [onlineAssetsProp]="'designAssets'"
          [offlineAssetsProp]="'offlineDesignAssets'"
          [label]="'+ Impressie'"
        ></immo-task-asset-uploader>
      </div>
      <div class="uploader-container">
        <immo-task-asset-uploader
          [task]="task"
          [onlineAssetsProp]="'locationAssets'"
          [offlineAssetsProp]="'offlineLocationAssets'"
          [label]="'+ Foto locatie'"
        ></immo-task-asset-uploader>
      </div>
    </div>

    <div class="d-flex">
      <div class="asap-checkbox">
        <checkbox
          [text]="'De taak moet ASAP uitgevoerd worden'"
          [checked]="task.requestedASAP"
          (answer)="requestedASAPChanged($event)"
        ></checkbox>
      </div>
      <div class="next-to-checkbox"><b>OF</b></div>
      <mat-form-field class="next-to-checkbox-last" appearance="outline">
        <input
          matInput
          [matDatepicker]="requestedDatePicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="task.requestedDate"
          (ngModelChange)="requestedDateChanged($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="requestedDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #requestedDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="border-section-header">
      <div class="border-section-header-text">
        <div>Uitvoering</div>
      </div>
    </div>

    <div class="border-content">
      <div class="border-content-container border-inner-info">
        <mat-card class="top-card mat-elevation-z0 overflowHidden">
          <div class="d-flex">
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                [(ngModel)]="task.placerId"
                (ngModelChange)="placerChanged($event)"
                placeholder="Kies"
              >
                <mat-option [value]="null"> Geen installateur </mat-option>
                <mat-option [value]="-1"> Bij alle installateurs </mat-option>
                <mat-option
                  *ngFor="let option of placerChoices"
                  [value]="option.id"
                >
                  {{
                    option.user?.firstName | personName : option.user?.lastName
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <impersonate-icon
              class="mt-3"
              *ngIf="!client && placer != null"
              [user]="placer?.user"
            >
            </impersonate-icon>

            <mat-form-field class="left-space" appearance="outline">
              <input
                matInput
                [min]="today"
                [matDatepicker]="tourDatePicker"
                placeholder="Selecteer een datum"
                [(ngModel)]="task.tourDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="tourDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #tourDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-checkbox
              class="left-space align-lock-checkbox"
              [(ngModel)]="task.locked"
              >LOCK
            </mat-checkbox>
            <mat-form-field class="left-space" appearance="outline">
              <input
                matInput
                [ngModel]="executionTime"
                (ngModelChange)="updateExecutionTime($event)"
                placeholder="Selecteer een tijdstip"
                [ngxMatTimepicker]="executionTimepicker"
                [format]="24"
                [ngModelOptions]="{ standalone: true }"
                readonly
              />
              <ngx-mat-timepicker #executionTimepicker></ngx-mat-timepicker>
            </mat-form-field>
            <div
              *ngIf="task.placerId != null && task.tourDate != null"
              class="left-space"
            >
              <button
                mat-button
                class="button reset-tour-button"
                (click)="resetTour()"
              >
                Maak los van toer
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <map
      [inputAddress]="task.address"
      [showMap]="false"
      [client]="true"
      (outputAddress)="task.address = $event"
    ></map>
    <small class="map-info secondary-color"
      >*maak gebruik van de autocomplete om een correct adress te vormen</small
    >

    <hr />

    <mat-checkbox
      [(ngModel)]="task.executed"
      (ngModelChange)="executedChanged($event)"
    >
      <span>Taak uitgevoerd </span>
      <span *ngIf="task.executed && task.executedRegistration != null">
        door
        {{
          task.executedRegistration.by?.firstName
            | personName : task.executedRegistration.by?.lastName
        }}
        -
        {{
          task.executedRegistration.date
            | formatDate : '' : 'dd/MM/yyyy - HH:mm'
        }}
      </span>
    </mat-checkbox>

    <div class="do-pad-bottom-less">
      <textarea-input
        [initContent]="task.executionFeedback"
        [placeholder]="'Feedback installateur'"
        [client]="true"
        (answer)="task.executionFeedback = $event"
      ></textarea-input>
    </div>

    <div class="d-flex justify-content-between">
      <immo-task-asset-uploader
        [task]="task"
        [onlineAssetsProp]="'executionAssets'"
        [offlineAssetsProp]="'offlineExecutionAssets'"
        [label]="'+ Foto opladen'"
      ></immo-task-asset-uploader>

      <div class="close-button-container">
        <div
          *ngIf="task.placerId === -1"
          class="d-flex align-items-center text-warning mb-2"
          style="font-size: 0.9em; font-style: italic"
        >
          <mat-icon class="me-1" style="font-size: 16px">info</mat-icon>
          Er wordt een taak aangemaakt voor elke installateur
        </div>
        <ng-container *ngIf="!submitting">
          <button
            class="btn close-button"
            [disabled]="archiving"
            (click)="closeDialog()"
          >
            Sluiten
          </button>
          <button
            mat-button
            class="close-button save-button"
            [disabled]="archiving"
            (click)="saveTask()"
          >
            Opslaan
          </button>
        </ng-container>
        <ng-container *ngIf="submitting">
          <mat-spinner color="primary" diameter="48"></mat-spinner>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
